import sectionCardMediaCss from '../css-snippets/section-card-media';

const html = `
<style>${sectionCardMediaCss}</style>
<div
  class="card-review-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-button-show="true"
  data-button-border-radius="8"
  data-rating-show="false"
  data-image-position="right"
  data-customer-review-enable="true"
  data-feature-list-enable="true"
>
  <div class="card-review-container-wrapper container">
    <div class="card-review-title">
      <h2 style="text-align: center">
        <strong>Protect Your Family From the Silent Killer</strong>
      </h2>
    </div>
    <div class="card-review-container">
      <div class="card-review-left">
        <div class="card-review-image">
          <img
            src="https://cdn.skyfastimg.com/images/2026/03/11/image-69b12a9fa21f577335e9502b.avif?w=50&h=50&q=80"
            alt="image"
          />
        </div>
      </div>
      <div class="card-review-right">
        <div class="card-review-content">
          <h2>
            <span style="color: #dd1d1dff"
              ><strong
                >Haven is an easy-to-use CO &amp; gas detector</strong
              > </span
            >that shows you real-time danger levels - so you can protect your
            family before it's too late.1
          </h2>
        </div>
        <div class="card-review-list">
          <div class="card-review-item">
            <div class="card-review-item-image">
              <img
                src="https://cdn.skyfastimg.com/images/2026/03/11/image-69b12f14b85f39d997e5f968.png?w=50&h=50&q=80"
                alt="image"
              />
            </div>
            <div class="card-review-item-text">
              <p>
                <i
                  ><strong>Guaranteed Satisfaction</strong> — Not 70 PPM like
                  cheap detectors that wait until it's too late</i
                >
              </p>
            </div>
          </div>
          <div class="card-review-item">
            <div class="card-review-item-image">
              <img
                src="https://cdn.skyfastimg.com/images/2026/03/11/image-69b12f14b85f39d997e5f968.png?w=50&h=50&q=80"
                alt="image"
              />
            </div>
            <div class="card-review-item-text">
              <p>
                <i
                  ><strong>Plug & Protect </strong> — No ladder, no tools, no
                  electrician. 30 seconds to install.</i
                >
              </p>
            </div>
          </div>
          <div class="card-review-item">
            <div class="card-review-item-image">
              <img
                src="https://cdn.skyfastimg.com/images/2026/03/11/image-69b12f14b85f39d997e5f968.png?w=50&h=50&q=80"
                alt="image"
              />
            </div>
            <div class="card-review-item-text">
              <p>
                <i
                  ><strong>Works for Whole Family </strong> — Protects kids,
                  parents, grandparents — everyone under your roof</i
                >
              </p>
            </div>
          </div>
        </div>
        <div class="card-review-button-container" data-button-min-width="400">
          <a href="#" class="card-review-button" data-button-border-radius="8" style="border-radius: 8px">
            <span class="card-review-button-text">GET 50% OFF TODAY ONLY!</span>
          </a>
          <div class="card-review-footer">
            <p>
              <span
                style="color: #dd1d1dff; font-weight: 500; font-style: italic"
                >NOT AVAILABLE ON AMAZON OR EBAY</span
              >
            </p>
          </div>
        </div>
        <div class="card-review-customer">
          <div class="card-review-customer-image">
            <img
              src="https://cdn.latteprint.com/latte/2025-08-22/1755856852631-167.jpg"
              alt="image"
            />
          </div>
          <div class="card-review-customer-info">
            <div class="card-review-customer-content">
              <p>
                "I was scrolling at 2 AM while nursing when I saw a video about a family who lost their toddler to CO poisoning. I threw up from anxiety. The next day I found Haven. The first night I installed it, I slept through until morning for the first time since my son was born. I look at that '0' every single day and exhale. I finally feel like the mom I'm supposed to be."
              </p>
            </div>
            <div class="card-review-customer-rating">
              <div data-full-stars="5" class="card-review-wrap-stars">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="0"
                  height="0"
                  style="position: absolute"
                >
                  <defs>
                    <linearGradient
                      id="half-star-gradient-infinite"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop
                        offset="50%"
                        style="stop-color: #f0b100; stop-opacity: 1"
                      />
                      <stop
                        offset="50%"
                        style="stop-color: #f0b100; stop-opacity: 0"
                      />
                    </linearGradient>
                  </defs>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
              </div>
              <div class="card-review-customer-name">
                <p>— Alvina Z.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
